import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { CheckCircle, PieChart, HourglassEmpty } from "@mui/icons-material";

export default function CurrentPlan({ quota }: { quota: any }) {
  return (
    <Card elevation={3} sx={{ borderRadius: 3, p: 2 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        My Current Plan
      </Typography>
      {quota && (
        <CardContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              backgroundColor: "#f9fafb",
              borderRadius: 2,
              p: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckCircle color="primary" />
              <Typography variant="body1">
                <b>Plan:</b> {quota.planName} ({quota.planCode})
              </Typography>
            </Box>

            <Divider />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PieChart color="secondary" />
              <Typography variant="body1">
                <b>Usage:</b> {quota.used} /{" "}
                {quota.quota === Infinity ? "∞" : quota.quota}
              </Typography>
            </Box>

            <Divider />

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <HourglassEmpty color="action" />
              <Typography variant="body1">
                <b>Remaining:</b>{" "}
                {quota.remaining === Infinity ? "∞" : quota.remaining}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      )}
    </Card>
  );
}
